/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfBoolean } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewDraftEmployeeSchedulePatternDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewEmployeeSchedulePatternDto } from '../api-models';
// @ts-ignore
import { CreateDraftEmployeeSchedulePatternDto } from '../api-models';
// @ts-ignore
import { SyncLegacySchedulePatternsResponse } from '../api-models';
// @ts-ignore
import { ViewEmployeeSchedulePatternDto } from '../api-models';
/**
 * SchedulePatternApi - axios parameter creator
 * @export
 */
export const SchedulePatternApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirm overbudgeting
         * @param {number} draftPatternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsConfirmOverbudgetingDraftPatternIdPost: async (draftPatternId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftPatternId' is not null or undefined
            assertParamExists('schedulePatternsConfirmOverbudgetingDraftPatternIdPost', 'draftPatternId', draftPatternId)
            const localVarPath = `/SchedulePatterns/confirm-overbudgeting/{draftPatternId}`
                .replace(`{${"draftPatternId"}}`, encodeURIComponent(String(draftPatternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables and removes the schedule pattern for a specific employee.
         * @param {number} employeeId The ID of the employee whose schedule pattern will be disabled and removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsDisableEmployeeIdPut: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('schedulePatternsDisableEmployeeIdPut', 'employeeId', employeeId)
            const localVarPath = `/SchedulePatterns/disable/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Discard draft employee schedule patterns
         * @param {number} draftPatternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsDiscardDraftDraftPatternIdPost: async (draftPatternId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftPatternId' is not null or undefined
            assertParamExists('schedulePatternsDiscardDraftDraftPatternIdPost', 'draftPatternId', draftPatternId)
            const localVarPath = `/SchedulePatterns/discard-draft/{draftPatternId}`
                .replace(`{${"draftPatternId"}}`, encodeURIComponent(String(draftPatternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsDraftPatternsEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('schedulePatternsDraftPatternsEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/SchedulePatterns/draft-patterns/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publish draft schedule patterns
         * @param {number} draftPatternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsPublishDraftDraftPatternIdPost: async (draftPatternId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftPatternId' is not null or undefined
            assertParamExists('schedulePatternsPublishDraftDraftPatternIdPost', 'draftPatternId', draftPatternId)
            const localVarPath = `/SchedulePatterns/publish-draft/{draftPatternId}`
                .replace(`{${"draftPatternId"}}`, encodeURIComponent(String(draftPatternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check for overbudgeting and save as draft
         * @param {CreateDraftEmployeeSchedulePatternDto} [createDraftEmployeeSchedulePatternDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsSaveDraftPost: async (createDraftEmployeeSchedulePatternDto?: CreateDraftEmployeeSchedulePatternDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/SchedulePatterns/save-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftEmployeeSchedulePatternDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Synchronizes legacy employee schedule patterns into the Pro system.
         * @param {number} [facilityId] Facility ID: &#x60;null&#x60; or empty for single facility, required for multi facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost: async (facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/SchedulePatterns/sync-legacy-employee-schedule-patterns-to-pro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks if user is allowed to go over budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsUserpermissionOverbudgetGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/SchedulePatterns/userpermission/overbudget`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulePatternApi - functional programming interface
 * @export
 */
export const SchedulePatternApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulePatternApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Confirm overbudgeting
         * @param {number} draftPatternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsConfirmOverbudgetingDraftPatternIdPost(draftPatternId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsConfirmOverbudgetingDraftPatternIdPost(draftPatternId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disables and removes the schedule pattern for a specific employee.
         * @param {number} employeeId The ID of the employee whose schedule pattern will be disabled and removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsDisableEmployeeIdPut(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEmployeeSchedulePatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsDisableEmployeeIdPut(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Discard draft employee schedule patterns
         * @param {number} draftPatternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsDiscardDraftDraftPatternIdPost(draftPatternId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsDiscardDraftDraftPatternIdPost(draftPatternId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsDraftPatternsEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewDraftEmployeeSchedulePatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsDraftPatternsEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Publish draft schedule patterns
         * @param {number} draftPatternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsPublishDraftDraftPatternIdPost(draftPatternId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewEmployeeSchedulePatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsPublishDraftDraftPatternIdPost(draftPatternId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check for overbudgeting and save as draft
         * @param {CreateDraftEmployeeSchedulePatternDto} [createDraftEmployeeSchedulePatternDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsSaveDraftPost(createDraftEmployeeSchedulePatternDto?: CreateDraftEmployeeSchedulePatternDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewDraftEmployeeSchedulePatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsSaveDraftPost(createDraftEmployeeSchedulePatternDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Synchronizes legacy employee schedule patterns into the Pro system.
         * @param {number} [facilityId] Facility ID: &#x60;null&#x60; or empty for single facility, required for multi facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost(facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncLegacySchedulePatternsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Checks if user is allowed to go over budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schedulePatternsUserpermissionOverbudgetGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schedulePatternsUserpermissionOverbudgetGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchedulePatternApi - factory interface
 * @export
 */
export const SchedulePatternApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulePatternApiFp(configuration)
    return {
        /**
         * 
         * @summary Confirm overbudgeting
         * @param {SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsConfirmOverbudgetingDraftPatternIdPost(requestParameters: SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.schedulePatternsConfirmOverbudgetingDraftPatternIdPost(requestParameters.draftPatternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disables and removes the schedule pattern for a specific employee.
         * @param {SchedulePatternApiSchedulePatternsDisableEmployeeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsDisableEmployeeIdPut(requestParameters: SchedulePatternApiSchedulePatternsDisableEmployeeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ViewEmployeeSchedulePatternDto> {
            return localVarFp.schedulePatternsDisableEmployeeIdPut(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Discard draft employee schedule patterns
         * @param {SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsDiscardDraftDraftPatternIdPost(requestParameters: SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.schedulePatternsDiscardDraftDraftPatternIdPost(requestParameters.draftPatternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsDraftPatternsEmployeeIdGet(requestParameters: SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewDraftEmployeeSchedulePatternDto> {
            return localVarFp.schedulePatternsDraftPatternsEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Publish draft schedule patterns
         * @param {SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsPublishDraftDraftPatternIdPost(requestParameters: SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewEmployeeSchedulePatternDto> {
            return localVarFp.schedulePatternsPublishDraftDraftPatternIdPost(requestParameters.draftPatternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check for overbudgeting and save as draft
         * @param {SchedulePatternApiSchedulePatternsSaveDraftPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsSaveDraftPost(requestParameters: SchedulePatternApiSchedulePatternsSaveDraftPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewDraftEmployeeSchedulePatternDto> {
            return localVarFp.schedulePatternsSaveDraftPost(requestParameters.createDraftEmployeeSchedulePatternDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Synchronizes legacy employee schedule patterns into the Pro system.
         * @param {SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost(requestParameters: SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SyncLegacySchedulePatternsResponse> {
            return localVarFp.schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks if user is allowed to go over budget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulePatternsUserpermissionOverbudgetGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfBoolean> {
            return localVarFp.schedulePatternsUserpermissionOverbudgetGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for schedulePatternsConfirmOverbudgetingDraftPatternIdPost operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPostRequest
 */
export interface SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPost
     */
    readonly draftPatternId: number
}

/**
 * Request parameters for schedulePatternsDisableEmployeeIdPut operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsDisableEmployeeIdPutRequest
 */
export interface SchedulePatternApiSchedulePatternsDisableEmployeeIdPutRequest {
    /**
     * The ID of the employee whose schedule pattern will be disabled and removed.
     * @type {number}
     * @memberof SchedulePatternApiSchedulePatternsDisableEmployeeIdPut
     */
    readonly employeeId: number
}

/**
 * Request parameters for schedulePatternsDiscardDraftDraftPatternIdPost operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPostRequest
 */
export interface SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPost
     */
    readonly draftPatternId: number
}

/**
 * Request parameters for schedulePatternsDraftPatternsEmployeeIdGet operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGetRequest
 */
export interface SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for schedulePatternsPublishDraftDraftPatternIdPost operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPostRequest
 */
export interface SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPost
     */
    readonly draftPatternId: number
}

/**
 * Request parameters for schedulePatternsSaveDraftPost operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsSaveDraftPostRequest
 */
export interface SchedulePatternApiSchedulePatternsSaveDraftPostRequest {
    /**
     * 
     * @type {CreateDraftEmployeeSchedulePatternDto}
     * @memberof SchedulePatternApiSchedulePatternsSaveDraftPost
     */
    readonly createDraftEmployeeSchedulePatternDto?: CreateDraftEmployeeSchedulePatternDto
}

/**
 * Request parameters for schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost operation in SchedulePatternApi.
 * @export
 * @interface SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPostRequest
 */
export interface SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPostRequest {
    /**
     * Facility ID: &#x60;null&#x60; or empty for single facility, required for multi facility.
     * @type {number}
     * @memberof SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost
     */
    readonly facilityId?: number
}

/**
 * SchedulePatternApi - object-oriented interface
 * @export
 * @class SchedulePatternApi
 * @extends {BaseAPI}
 */
export class SchedulePatternApi extends BaseAPI {
    /**
     * 
     * @summary Confirm overbudgeting
     * @param {SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsConfirmOverbudgetingDraftPatternIdPost(requestParameters: SchedulePatternApiSchedulePatternsConfirmOverbudgetingDraftPatternIdPostRequest, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsConfirmOverbudgetingDraftPatternIdPost(requestParameters.draftPatternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disables and removes the schedule pattern for a specific employee.
     * @param {SchedulePatternApiSchedulePatternsDisableEmployeeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsDisableEmployeeIdPut(requestParameters: SchedulePatternApiSchedulePatternsDisableEmployeeIdPutRequest, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsDisableEmployeeIdPut(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Discard draft employee schedule patterns
     * @param {SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsDiscardDraftDraftPatternIdPost(requestParameters: SchedulePatternApiSchedulePatternsDiscardDraftDraftPatternIdPostRequest, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsDiscardDraftDraftPatternIdPost(requestParameters.draftPatternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsDraftPatternsEmployeeIdGet(requestParameters: SchedulePatternApiSchedulePatternsDraftPatternsEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsDraftPatternsEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Publish draft schedule patterns
     * @param {SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsPublishDraftDraftPatternIdPost(requestParameters: SchedulePatternApiSchedulePatternsPublishDraftDraftPatternIdPostRequest, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsPublishDraftDraftPatternIdPost(requestParameters.draftPatternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check for overbudgeting and save as draft
     * @param {SchedulePatternApiSchedulePatternsSaveDraftPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsSaveDraftPost(requestParameters: SchedulePatternApiSchedulePatternsSaveDraftPostRequest = {}, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsSaveDraftPost(requestParameters.createDraftEmployeeSchedulePatternDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Synchronizes legacy employee schedule patterns into the Pro system.
     * @param {SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost(requestParameters: SchedulePatternApiSchedulePatternsSyncLegacyEmployeeSchedulePatternsToProPostRequest = {}, options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsSyncLegacyEmployeeSchedulePatternsToProPost(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks if user is allowed to go over budget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulePatternApi
     */
    public schedulePatternsUserpermissionOverbudgetGet(options?: AxiosRequestConfig) {
        return SchedulePatternApiFp(this.configuration).schedulePatternsUserpermissionOverbudgetGet(options).then((request) => request(this.axios, this.basePath));
    }
}
